<script>
  export let routeId;
  export let onlyMap = true;
  export let routeMapIDs = [];
  export let firstMapOnPage = true;

  import {
    googleMapsReady,
    routesForMapWithScheduleWithEncodedLine,
    mapVehiclePoints
  } from "../store.js";
  import Map from "../components/Map.svelte";
  //let googleMapsAPIKey = "AIzaSyBzXaourRANRyOmrjQnU-GdRXh-GBVDSV4"; //rdytogo dev key
  let googleMapsAPIKey = "AIzaSyBUDFSIk8-a3zIm599wdwxhaUk9gvYKj4s"; // keith's production key
  //let googleMapsAPIKey ="AIzaSyC0MWVctLFtnq1bnSc27TkBS28b3c7k32Q"; // coastridetracker.com key

  $: myRoutes = $routesForMapWithScheduleWithEncodedLine.filter(route => {
    return parseInt(route.RouteID) === parseInt(routeId);
  });

  $: routesDisplayedOnPage = $routesForMapWithScheduleWithEncodedLine.filter(
    route => {
      return routeMapIDs.includes(String(route.RouteID));
    }
  );

  $: myVehiclePoints = $mapVehiclePoints.filter(route => {
    return parseInt(route.RouteID) === parseInt(routeId);
  });
  $: myRoute =
    myRoutes.length === 0
      ? { Description: "", EncodedPolyline: "", Stops: [], IsRunning: false }
      : myRoutes[0];
  $: isRunning = myRoute.IsRunning;
  $: mapCenter = {
    lat: myRoute.MapLatitude,
    lng: myRoute.MapLongitude
  };
  $: mapZoom = myRoute.MapZoom;
  $: polylines = [
    {
      path: myRoute.EncodedPolyline,
      geodesic: true,
      strokeColor: myRoute.MapLineColor,
      strokeOpacity: 0.5,
      strokeWeight: 4
    }
  ];
  $: markers = [...myRoute.Stops].map(stop => {
    return {
      position: { lat: stop.Latitude, lng: stop.Longitude },
      title: stop.Description,
      label: stop.Description
    };
  });
  $: busMarkers = [...myVehiclePoints].map(bus => {
    return {
      position: { lat: bus.Latitude, lng: bus.Longitude },
      title: bus.Name,
      label: bus.Name,
      heading: bus.Heading
    };
  });

  $: noRoutesRunning = routesDisplayedOnPage.reduce((acc, route) => {
    if (isRunning) return false; // if current route is running, then this should be false
    if (acc === false) return false; // if a previously checked route was false, then we need to return false
    return !route.IsRunning; // finally, if the previous two conditions were returned true, we can check the current route.
  }, true);

  $: showThisMap = onlyMap || isRunning || (noRoutesRunning && firstMapOnPage);
</script>

<style>
  span {
    color: white;
    position: relative;
    top: -40px;
    margin-bottom: -40px;
  }
</style>

<svelte:head>
  <script
    defer
    async
    src="https://maps.googleapis.com/maps/api/js?key={googleMapsAPIKey}&libraries=geometry&callback=initMap">

  </script>
</svelte:head>
{#if showThisMap}
  {#if $googleMapsReady && myRoute.Description !== ''}
    <Map center={mapCenter} zoom={mapZoom} {polylines} {markers} {busMarkers} />
    <span>{myRoute.Description}</span>
  {/if}
{/if}
